import { createServerFn } from "@tanstack/react-start";
import { detectDeviceFromHeaders, type DeviceKind } from "./device-hint.server";

/**
 * Resolve the requesting device during SSR so the homepage can render ONE
 * hero tree instead of server-rendering and hydrating both the mobile and
 * desktop branches (the dominant cost in the 377ms hydration commit).
 */
export const getDeviceHint = createServerFn({ method: "GET" }).handler(
  async (): Promise<DeviceKind> => {
    const { getRequestHeader } = await import("@tanstack/react-start/server");
    return detectDeviceFromHeaders({
      secChUaMobile: getRequestHeader("sec-ch-ua-mobile") ?? null,
      userAgent: getRequestHeader("user-agent") ?? null,
    });
  },
);
